import { MatTableDataSource, MatPaginator, MatFormFieldModule } from '@angular/material';
import { ConfiguracionesService } from '../../../../shared/configuraciones.service';
import { Component, ViewChild, OnInit, ViewEncapsulation, ElementRef, Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import {MatDialog,MatDialogRef,MAT_DIALOG_DATA} from '@angular/material/dialog'
import { Router } from '@angular/router';
import { DialogAgregarTipoTel } from '../dialogAgregarTipoTel/dialogAgregarTipoTel.component';
import { DialogEliminarTipoTel } from '../dialogEliminarTipoTel/dialogEliminarTipoTel.component';
import { DialogEditarTipoTel } from '../dialogEditarTipoTel/dialogEditarTipoTel.component';

export interface DialogData {
  idTipoTel: string;
  tipo: string;
  descripcion: string;
  tipoanterior: string;
  descripcionanterior: string;
}
@Component({
  selector: 'app-FragmentTipoTel',
  templateUrl: './FragmentTipoTel.component.html',
  styleUrls: ['./FragmentTipoTel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
@Injectable()
export class FragmentTipoTel implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public codigo;
  public iscargado = true;
  public ismenu = false;
  bancovalue: string;
  constructor(private route: Router,private configuracionesService: ConfiguracionesService, public toastr: ToastrManager,public dialogEliminar: MatDialog,public dialog: MatDialog,public dialogagregar: MatDialog) {

  
  }

   idTipoTel: string;
   tipo: string;
   descripcion: string;
   tipoanterior: string;
   descripcionanterior: string;

   displayedColumns: string[] = ['idTipoTel', 'tipo','descripcion','editar','eliminar'];
   dataSource = new MatTableDataSource();

 
  ngOnInit(): void {

    this.descargarConfiguraciones()
    this.descargarConTipoDoc()  
  
  }

  
  ngAfterViewInit() {

    this.dataSource.paginator = this.paginator;

  }


  descargarConfiguraciones() {

    this.configuracionesService.getTiposTel().subscribe(configuraciones => {
  
      this.dataSource.data = configuraciones;

      setTimeout(() => {
        this.iscargado = false;
        this.ismenu = true;
       }, 200);

    
  
    
    });
  }

  descargarConTipoDoc() {

    this.configuracionesService.getConTipoTel ().subscribe(tipoTel => {
      console.log('tipoTel',tipoTel);
      for (let tipo of tipoTel) {

           this.codigo=tipo.contel
           console.log('contel',tipo.contel);
      
      }  

    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  editar(tipo: any) {

    this.dialog.open(DialogEditarTipoTel, {
      width: '350px',
      data: {idTipoTel: tipo.idTipoTel,
        tipo:tipo.tipo,
        descripcion:tipo.descripcion,
        tipoanterior:tipo.tipo,
        descripcionanterior:tipo.descripcion},
    });
   

  }

  nuevoBanco():void {

    this.dialogagregar.open(DialogAgregarTipoTel, {
      width: '350px',
      data: {idTipoTel: this.codigo,tipo:'',descripcion:''},
    
    });
  
    }

  deletebanco(tipo: any) {

    this.dialogEliminar.open(DialogEliminarTipoTel, {
      width: '350px',
      data: {idTipoTel: tipo.idTipoTel,tipo:tipo.tipo,descripcion:tipo.descripcion},
    });
  
  }

  
  auditoria():void {

    this.route.navigate(['/AuditoriaTipoTel']);
    
  }
  
}
